export function getHashFilter() {
  // get filter=filterName
  const matches = location.hash.match(/filter=([^&]+)/i);
  const hashFilter = matches && matches[1];
  return hashFilter && decodeURIComponent(hashFilter);
}

export function handleize(str) {
  str = str.toLowerCase();

  const toReplace = ['"', "'", "\\", "(", ")", "[", "]"];

  // For the old browsers
  for (let i = 0; i < toReplace.length; ++i) {
    str = str.replace(toReplace[i], "");
  }

  str = str.replace(/\W+/g, "-");

  if (str.charAt(str.length - 1) === "-") {
    str = str.replace(/-+z/, "");
  }

  if (str.charAt(0) === "-") {
    str = str.replace(/A-+/, "");
  }

  return str;
}

export const createTypes = (types) => {
  if (Array.isArray(types)) {
    return types.reduce((typesMap, type) => {
      const request = type + "_REQUEST";
      const success = type + "_SUCCESS";
      const fail = type + "_FAIL";

      return {
        ...typesMap,
        [request]: request,
        [success]: success,
        [fail]: fail,
      };
    }, {});
  } else {
    const request = types + "_REQUEST";
    const success = types + "_SUCCESS";
    const fail = types + "_FAIL";

    return {
      [request]: request,
      [success]: success,
      [fail]: fail,
    };
  }
};

export const getQueryStringParameter = (name) => {
  const url = new URL(window.location);
  return url.searchParams.get(name);
};

export const setQueryStringParameter = (name, value) => {
  const params = new URLSearchParams(window.location.search);
  params.set(name, value);
  window.history.replaceState(
    {},
    "",
    decodeURIComponent(`${window.location.pathname}?${params}`)
  );
};

export const getFocusableElements = (parentNode) =>
  parentNode.querySelectorAll(
    'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])'
  );

export function debounce(func, wait, immediate) {
  let timeout;

  return function executedFunction() {
    const context = this;
    const args = arguments;

    const later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };

    const callNow = immediate && !timeout;

    clearTimeout(timeout);

    timeout = setTimeout(later, wait);

    if (callNow) func.apply(context, args);
  };
}

export function getSelectedVariant(handle, variantId) {
  fetch(`/products/${handle}.js`)
    .then((res) => res.json())
    .then((product) => {
      const variant = product.variants.find(
        (v) => parseInt(v.id) === parseInt(variantId)
      );
      const detailData = {
        product,
        variantData: variant,
      };
      const initialVariantEvent = new CustomEvent(
        "attentive-variant-selected",
        {
          detail: detailData,
        }
      );
      window.dispatchEvent(initialVariantEvent);
    })
    .catch((e) => {
      return null;
    });
}

function animateOverTime(dur, cb, fin) {
  let timeStart;
  // create closure
  function _animateOverTime(time) {
    if (!timeStart) timeStart = time;
    const timeElapsed = time - timeStart;
    const complete = Math.min(timeElapsed / dur, 1);
    cb(complete);

    if (timeElapsed < dur) {
      requestAnimationFrame(_animateOverTime);
    } else {
      if (typeof fin === "function") fin();
    }
  }

  return _animateOverTime;
}

export const fadeIn = (el, dur = 400, display = "block", fin = 1) => {
  el.style.display = display || "block";

  const _fadeIn = function (complete) {
    el.style.opacity = complete;
  };

  const ani = animateOverTime(dur, _fadeIn, fin);
  requestAnimationFrame(ani);
};

export const fadeOut = (el, dur = 400, fin = 0) => {
  const _fadeOut = function (complete) {
    el.style.opacity = 1 - complete;
    if (complete === 1) {
      el.style.opacity = null;
      el.style.display = "none";
    }
  };

  const ani = animateOverTime(dur, _fadeOut, fin);
  requestAnimationFrame(ani);
};

export const getVariantLink = (variantId, productHandle) => {
  return `/products/${productHandle}?variant=${variantId}`;
};
